import _ from 'lodash';
import defaultConfig from './config.default';

const config = _.assign({}, defaultConfig, {
  CHROMECAST_APP_ID: 'A508E8B6',
  GOOGLE_TRACK_ID: 'UA-102183233-1',
});

export default config;



// WEBPACK FOOTER //
// ./src/config/config.production.js